// @packages
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import HomeIcon from '@material-ui/icons/Home';
import Link from '@material-ui/core/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import { config } from '../../../../config';
import { globalUI } from '../../../../core';
import fanSizerSubmenu from '../../../../config/menus/fan-sizer-submenu.json';

// @styles
import styles from './styles';

const CtrlBreadcrum = ({
    classes,
    currentUrl,
    id
}) => {
    const urls = currentUrl.split('/').reduce((acc, current) => [...acc, `${acc}/${current}`]);
    const getDescription = (url) => {
        let route = config.routes.find((route) => route.url === url);
        if(!route) route = fanSizerSubmenu.find((route) => route.url === url);
        return route ? config.text.routes[route.name] : '';
    };

    return (
        <Breadcrumbs aria-label="breadcrumb" id={id}>
            <Link
                className={classes.link}
                color="inherit"
                component="button"
                onClick={() => globalUI.navigateToUrl('/')}               
            >                
                <HomeIcon className={classes.icon} />                
            </Link>
            / 
            <Link
                className={classes.link}
                color="inherit"
                component="button"
                onClick={() => globalUI.navigateToUrl('/')}               
            >              
         
                Products
            </Link>
            { urls.find((url) => url !== '/') && urls.map((url, index) => (
                <Link
                    className={classes.link}
                    color="inherit"
                    component="button"
                    onClick={() => globalUI.navigateToUrl(url)}
                    key={index}
                >
                    {getDescription(url)}
                </Link>
            ))}
        </Breadcrumbs>
    );
};

CtrlBreadcrum.propTypes = {
    classes: PropTypes.object.isRequired,
    currentUrl: PropTypes.string,
    id: PropTypes.string.isRequired
};

CtrlBreadcrum.defaultProps = {
    currentUrl: null
};

export default withStyles(styles)(CtrlBreadcrum);
